import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ l("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-588 -16)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0.000671387H0V20H20V0.000671387Z",
      fill: "#496E2D"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H10V19.9998H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M12.4765 7.84198L11.5535 9.114L10.0586 8.62924L10.9831 9.90012L10.0601 11.1721L11.5545 10.6855L12.479 11.9564L12.478 10.3849L13.9724 9.89832L12.4775 9.4136L12.4765 7.84198Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10.9914 13.1792C9.23547 13.1792 7.81203 11.7558 7.81203 9.99988C7.81203 8.244 9.23547 6.82058 10.9914 6.82058C11.5388 6.82058 12.054 6.95901 12.5038 7.20272C11.7982 6.51277 10.8333 6.08691 9.76852 6.08691C7.60742 6.08691 5.85547 7.83885 5.85547 9.99992C5.85547 12.161 7.60742 13.9129 9.76852 13.9129C10.8333 13.9129 11.7982 13.4871 12.5038 12.7971C12.0539 13.0407 11.5388 13.1792 10.9914 13.1792Z",
      fill: "#D80027"
    })
  ]
});
export {
  r as default
};
